<script src="https://static.line-scdn.net/liff/edge/2/sdk.js"></script>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>
<template>
  <v-container>
    <v-layout text-center wrap>
      <v-flex xs12>
        <img src='https://misemeg.jp/owner/mb/assets/images/common/misemeg_icon.svg' height="100px" width="100px">
      </v-flex>
      <br />
      <br />
      <v-flex mb-4 xs12>
        <h4>エラーが発生しました</h4>
        <br />
        <h5>会員証登録時にこの画面が表示される場合は<br />LINEの「アカウント」画面で「メールアドレス」が<br />正しく設定されているかをご確認ください。</h5>
        <br />
        <br />
        <h5>※会員証登録済みの場合はしばらくしてから再度お試しください</h5>
        <!--
        <div class="ma-4" id="top_button">
          <v-btn large color="success" @click="return2top" title="デジタル会員証を表示する" id="return2top_btn">デジタル会員証を表示する</v-btn>
        </div>
        -->
      </v-flex>
      <br />
      <br />
      <!-- Snackbar -->
      <div>
        <v-snackbar v-model="snackbarFlag" color="primary" multi-line :timeout="snackbarTimeout" top>
          {{ snackbarText }}
        </v-snackbar>
      </div>
      <br />
      <br />      
      <v-flex mb-4 xs12>
        <div class="ma-4">
          <br />
          <br />
          <span id="copyright"><a href="https://www.busicom.co.jp/product/misemeg/mini/?openExternalBrowser=1"
              target="_blank">&emsp;みせめぐ&nbsp;&times;&nbsp;LINEミニアプリ&emsp;<br />&emsp;Copyright &copy;
              BUSICOM.Co.,ltd. </a></span>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style>
 .v-main{
  background-color:#f3f3f3;
 }
 #member_info_tbl{
  margin: 0 auto;
  color:navy;
 }
 #line_logout{
  margin: 0 auto;
 }
</style>
<script>
export default {
  data () {
    return {
      snackbarFlag: false,
      snackbarTimeout: 3000,
      snackbarText: '',
      name: '',
      imgURL: '',
      userId: '',
      email: '',
      barcode_url: '',
      inClient: false
    }
  },
  created () {
    this.initializeLiff();    
  },
  mounted (){
  },
  methods: {
    initializeLiff: function () {
      var me = this
      liff.init(
        {
          liffId: process.env.VUE_APP_LIFF_ID
        },
        data => {

        },
        err => {
          console.log('LIFF initialization failed', err)
        }
      )
    },
    logout: function () {
      // ログアウト
      if (liff.isLoggedIn()) {
        liff.logout()
        this.$router.push({ name: 'home' })
      }
    },
    return2top: function () {
      // デジタル会員証表示ボタン（＝TOP画面に戻る）
      this.$router.push({ name: 'home' })
    },
    showSnackbar(text) {
      this.snackbarFlag = true
      this.snackbarText = text
      setTimeout(()=> {
          this.snackbarFlag = false
          this.snackbarText = ''
        },
        this.snackbarTimeout
      )
    }
  }
}
</script>